export default __webpack_public_path__ + "static/media/art1.1329c821.jpg";